var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":""},on:{"enter":_vm.enter,"leave":_vm.leave}},[(_vm.$store.state.currentGame.questionsIndex < 0
      || _vm.$store.state.currentGame.questionsIndex === null)?_c('span',{staticClass:"bg-illustration"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }